// Tells the rest of the page where the Klaro cookie notice is, so the page can
// make room for it (styles in assets/klaro-theme.css and public/index.html):
//   html.gp-cookie-notice-open    the notice is showing
//   html.gp-cookie-settings-open  the settings are showing (Customise, Manage cookies)
//   --gp-cookie-notice-space      how far the notice reaches up from the bottom of
//                                 the window, plus a 10px gap (notice only)
// Reads Klaro's DOM only; consent is untouched. Call after Klaro.setup().
export function trackCookieNotice() {
  const root = document.getElementById('klaro');
  if (!root) return;
  const html = document.documentElement;
  const resize = typeof ResizeObserver === 'function' ? new ResizeObserver(update) : null;
  let observed = null;

  function update() {
    const notice = root.querySelector('.cookie-notice:not(.cookie-notice-hidden)');
    const settings = root.querySelector('.cookie-modal');
    html.classList.toggle('gp-cookie-notice-open', !!notice);
    html.classList.toggle('gp-cookie-settings-open', !!settings);

    if (resize && notice !== observed) {
      if (observed) resize.unobserve(observed);
      if (notice) resize.observe(notice);
      observed = notice;
    }

    if (notice) {
      const space = Math.ceil(window.innerHeight - notice.getBoundingClientRect().top) + 10;
      html.style.setProperty('--gp-cookie-notice-space', `${space}px`);
    } else {
      html.style.removeProperty('--gp-cookie-notice-space');
    }
  }

  new MutationObserver(update).observe(root, { childList: true, subtree: true });
  window.addEventListener('resize', update);
  update();
}
